import React from 'react';
import { CreditCardIcon, LockIcon } from 'lucide-react';
export function PayButton() {
  const handlePayment = (e: React.FormEvent) => {
    e.preventDefault();
    // Payment logic will be handled by Stripe
    console.log('Processing payment...');
  };
  return <section className="max-w-lg mx-auto px-4 pb-6" data-id="element-43">
      <button onClick={handlePayment} className="w-full bg-champagne-gold hover:bg-champagne-gold/90 text-white font-semibold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 animate-glow" data-id="element-44">
        <span className="flex items-center justify-center gap-2 text-base" data-id="element-45">
          <CreditCardIcon className="w-5 h-5" data-id="element-46" />
          Pagar ahora y obtener acceso inmediato
        </span>
      </button>

      <div className="flex items-center justify-center gap-3 mt-3 text-xs text-deep-cocoa/70" data-id="element-47">
        <div className="flex items-center gap-1" data-id="element-48">
          <CreditCardIcon className="w-3.5 h-3.5" data-id="element-49" />
          <span data-id="element-50">Pago 100% seguro con Stripe</span>
        </div>
        <span className="text-deep-cocoa/40" data-id="element-51">•</span>
        <div className="flex items-center gap-1" data-id="element-52">
          <LockIcon className="w-3.5 h-3.5" data-id="element-53" />
          <span data-id="element-54">Acceso inmediato al confirmar</span>
        </div>
      </div>
    </section>;
}